import script from "./DoctorList.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoctorList.vue?vue&type=script&lang=ts&setup=true"

import "./DoctorList.vue?vue&type=style&index=0&id=4c7913be&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c7913be"]])

export default __exports__